const STATIC_CUSTOM_PRICING_TRENDS = [
  {
    EnerexSupplierIdentifier: "38e36fc8-0c9a-4774-9632-555e6c28bb37",
    Supplier: "Supplier A",
    Prices: [
      { Date: "01/23/26", Price: 0.07053 },
      { Date: "01/29/26", Price: 0.07099 },
      { Date: "02/05/26", Price: 0.07175 },
      { Date: "02/09/26", Price: 0.06765 },
      { Date: "02/19/26", Price: 0.06569 },
      { Date: "02/20/26", Price: 0.06634 },
      { Date: "02/24/26", Price: 0.06606 },
      { Date: "02/25/26", Price: 0.07016 },
      { Date: "03/01/26", Price: 0.0649 },
      { Date: "03/02/26", Price: 0.06754 },
      { Date: "03/03/26", Price: 0.06154 },
      { Date: "03/04/26", Price: 0.06638 },
      { Date: "03/05/26", Price: 0.06 },
      { Date: "03/06/26", Price: 0.06496 },
      { Date: "03/10/26", Price: 0.0689 },
      { Date: "03/11/26", Price: 0.06255 },
      { Date: "03/12/26", Price: 0.06966 },
      { Date: "03/13/26", Price: 0.06363 },
      { Date: "03/16/26", Price: 0.05899 },
      { Date: "03/17/26", Price: 0.0697 },
      { Date: "03/18/26", Price: 0.06876 },
      { Date: "03/19/26", Price: 0.07104 },
    ],
  },
  {
    EnerexSupplierIdentifier: "9c5337fd-2030-4510-bd57-c736bfdd8e35",
    Supplier: "Supplier B",
    Prices: [
      { Date: "01/30/26", Price: 0.06509 },
      { Date: "02/05/26", Price: 0.06377 },
      { Date: "02/09/26", Price: 0.06562 },
      { Date: "02/11/26", Price: 0.06637 },
      { Date: "02/19/26", Price: 0.06499 },
      { Date: "02/23/26", Price: 0.06309 },
      { Date: "02/24/26", Price: 0.07146 },
      { Date: "02/26/26", Price: 0.05381 },
      { Date: "03/01/26", Price: 0.06804 },
      { Date: "03/02/26", Price: 0.07843 },
      { Date: "03/03/26", Price: 0.06893 },
      { Date: "03/05/26", Price: 0.08449 },
      { Date: "03/06/26", Price: 0.08197 },
      { Date: "03/09/26", Price: 0.07356 },
      { Date: "03/10/26", Price: 0.08313 },
      { Date: "03/11/26", Price: 0.08086 },
      { Date: "03/12/26", Price: 0.08449 },
      { Date: "03/16/26", Price: 0.07162 },
    ],
  },
  {
    EnerexSupplierIdentifier: "64304cdd-0011-4a7e-b0e5-147c9ff78675",
    Supplier: "Supplier C",
    Prices: [
      { Date: "02/02/26", Price: 0.14399 },
      { Date: "02/09/26", Price: 0.128 },
      { Date: "02/11/26", Price: 0.06714 },
      { Date: "02/16/26", Price: 0.13199 },
      { Date: "02/18/26", Price: 0.07394 },
      { Date: "02/19/26", Price: 0.13699 },
      { Date: "02/26/26", Price: 0.09739 },
      { Date: "02/27/26", Price: 0.12899 },
      { Date: "03/04/26", Price: 0.14399 },
      { Date: "03/06/26", Price: 0.06089 },
      { Date: "03/10/26", Price: 0.08058 },
      { Date: "03/13/26", Price: 0.08858 },
    ],
  },
  {
    EnerexSupplierIdentifier: "6d13b50b-3260-4279-a3b5-1d7e68091abb",
    Supplier: "Supplier D",
    Prices: [
      { Date: "02/03/26", Price: 0.07349 },
      { Date: "02/25/26", Price: 0.07084 },
      { Date: "02/26/26", Price: 0.0653 },
      { Date: "03/01/26", Price: 0.07589 },
      { Date: "03/02/26", Price: 0.06324 },
      { Date: "03/05/26", Price: 0.06362 },
      { Date: "03/06/26", Price: 0.05191 },
      { Date: "03/09/26", Price: 0.06029 },
      { Date: "03/11/26", Price: 0.0681 },
      { Date: "03/13/26", Price: 0.08025 },
      { Date: "03/17/26", Price: 0.07274 },
    ],
  },
  {
    EnerexSupplierIdentifier: "875c7031-92cb-4abe-811f-1733a049ebf4",
    Supplier: "Supplier E",
    Prices: [
      { Date: "01/28/26", Price: 0.07023 },
      { Date: "02/24/26", Price: 0.06953 },
      { Date: "03/03/26", Price: 0.0696 },
      { Date: "03/05/26", Price: 0.04484 },
      { Date: "03/10/26", Price: 0.0605 },
      { Date: "03/11/26", Price: 0.06227 },
      { Date: "03/12/26", Price: 0.06198 },
      { Date: "03/13/26", Price: 0.0718 },
      { Date: "03/17/26", Price: 0.06811 },
    ],
  },
  {
    EnerexSupplierIdentifier: "6bd2c20f-0ce3-4b00-acde-63569a4273a1",
    Supplier: "Supplier F",
    Prices: [
      { Date: "02/03/26", Price: 0.0696 },
      { Date: "02/04/26", Price: 0.06842 },
      { Date: "02/06/26", Price: 0.06915 },
      { Date: "02/24/26", Price: 0.06545 },
      { Date: "02/25/26", Price: 0.06994 },
      { Date: "03/02/26", Price: 0.06639 },
      { Date: "03/03/26", Price: 0.06577 },
      { Date: "03/04/26", Price: 0.06111 },
      { Date: "03/17/26", Price: 0.06531 },
    ],
  },
  {
    EnerexSupplierIdentifier: "9189d491-b82a-4a2a-a5b8-3da874ee9ac3",
    Supplier: "Supplier G",
    Prices: [
      { Date: "01/28/26", Price: 0.06454 },
      { Date: "02/04/26", Price: 0.0651 },
      { Date: "02/06/26", Price: 0.06021 },
      { Date: "02/18/26", Price: 0.05826 },
      { Date: "03/19/26", Price: 0.061 },
    ],
  },
  {
    EnerexSupplierIdentifier: "b60c4da9-b357-40e1-bfd7-fdc6de54108e",
    Supplier: "Supplier H",
    Prices: [
      { Date: "02/05/26", Price: 0.07055 },
      { Date: "03/01/26", Price: 0.0687 },
      { Date: "03/16/26", Price: 0.10999 },
    ],
  },
  {
    EnerexSupplierIdentifier: "019b92b2-0e4a-427e-9917-61088dffaac5",
    Supplier: "Supplier I",
    Prices: [{ Date: "02/27/26", Price: 0.136 }],
  },
  {
    EnerexSupplierIdentifier: "41c9c9c8-f2e6-4b82-bdbe-c55243d41803",
    Supplier: "Supplier J",
    Prices: [
      { Date: "01/29/26", Price: 0.06761 },
      { Date: "03/16/26", Price: 0.06462 },
    ],
  },
  {
    EnerexSupplierIdentifier: "32a9e1a8-df19-4b70-8793-0d1695fd90df",
    Supplier: "Supplier K",
    Prices: [{ Date: "02/18/26", Price: 0.05905 }],
  },
  {
    EnerexSupplierIdentifier: "6ce62215-20c0-434e-8af6-4af301016ddb",
    Supplier: "Supplier L",
    Prices: [{ Date: "03/04/26", Price: 0.06199 }],
  },
];

const toSortedDates = (trendData) => {
  const allDates = trendData.flatMap((supplier) =>
    (supplier?.Prices || []).map((p) => p?.Date).filter(Boolean)
  );
  return [...new Set(allDates)].sort((a, b) => new Date(a) - new Date(b));
};

const getMedian = (values) => {
  if (!values.length) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 !== 0
    ? sorted[mid]
    : (sorted[mid - 1] + sorted[mid]) / 2;
};

const buildStaticPriceTrendMinMax = (trendData) => {
  const dates = toSortedDates(trendData);
  const pricesByDate = new Map();

  trendData.forEach((supplier) => {
    (supplier?.Prices || []).forEach((entry) => {
      if (!pricesByDate.has(entry.Date)) pricesByDate.set(entry.Date, []);
      pricesByDate.get(entry.Date).push(entry.Price);
    });
  });

  const Prices = dates.map((date) => {
    const values = (pricesByDate.get(date) || []).filter(
      (price) => typeof price === "number"
    );
    if (!values.length) {
      return {
        Date: date,
        Price: null,
        MinPrice: null,
        MaxPrice: null,
        MeanPrice: null,
        MedianPrice: null,
      };
    }

    const min = Math.min(...values);
    const max = Math.max(...values);
    const mean = values.reduce((sum, val) => sum + val, 0) / values.length;
    const median = getMedian(values);

    return {
      Date: date,
      Price: mean,
      MinPrice: min,
      MaxPrice: max,
      MeanPrice: mean,
      MedianPrice: median,
    };
  });

  return [
    {
      EnerexSupplierIdentifier: "00000000-0000-0000-0000-000000000000",
      Supplier: "Market",
      Prices,
    },
  ];
};

const STATIC_CUSTOM_PRICING_TRENDS_MIN_MAX =
  buildStaticPriceTrendMinMax(STATIC_CUSTOM_PRICING_TRENDS);

export {
  STATIC_CUSTOM_PRICING_TRENDS,
  STATIC_CUSTOM_PRICING_TRENDS_MIN_MAX,
};
